var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7029 4.11415C19.0071 4.42248 18.2596 4.63082 17.4737 4.72498C18.2846 4.23981 18.8912 3.4762 19.1804 2.57665C18.4186 3.02914 17.5849 3.34765 16.7154 3.51832C16.1307 2.89404 15.3563 2.48025 14.5124 2.34121C13.6684 2.20217 12.8022 2.34564 12.0481 2.74936C11.2941 3.15308 10.6944 3.79445 10.3422 4.5739C9.99003 5.35335 9.90503 6.22727 10.1004 7.05998C8.55682 6.98248 7.04677 6.58127 5.66827 5.8824C4.28977 5.18353 3.07362 4.20262 2.09875 3.00332C1.76542 3.57832 1.57375 4.24498 1.57375 4.95498C1.57338 5.59415 1.73078 6.22352 2.03198 6.78726C2.33319 7.351 2.76888 7.83168 3.30042 8.18665C2.68398 8.16704 2.08114 8.00047 1.54208 7.70082V7.75082C1.54202 8.64727 1.85211 9.51613 2.41974 10.21C2.98736 10.9038 3.77756 11.3799 4.65625 11.5575C4.0844 11.7122 3.48486 11.735 2.90292 11.6242C3.15083 12.3955 3.63375 13.07 4.28406 13.5533C4.93437 14.0365 5.71951 14.3043 6.52958 14.3192C5.15444 15.3987 3.45616 15.9842 1.70792 15.9816C1.39823 15.9817 1.08881 15.9636 0.78125 15.9275C2.55581 17.0685 4.62153 17.674 6.73125 17.6716C13.8729 17.6716 17.7771 11.7566 17.7771 6.62665C17.7771 6.45998 17.7729 6.29165 17.7654 6.12498C18.5248 5.57579 19.1803 4.89573 19.7013 4.11665L19.7029 4.11415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.099205ba64067b030f299dc696feb14d.svg";
export { ForwardRef as ReactComponent };